import React from 'react';
import {
    RiCalendarCheckLine,
    RiGraduationCapLine,
    RiBriefcaseLine,
    RiFingerprint2Line,
    RiHomeLine,
    RiMedalLine,
    RiBankLine,
    RiHeartLine,
    RiFileCheckLine,
    RiBuilding2Line,
    RiScales3Line,
    RiCarLine,
    RiTeamLine,
    RiVipCrownLine,
    RiTrophyLine,
    RiShieldKeyholeLine,
  } from "react-icons/ri";


  const iconMap = {
    RiCalendarCheckLine,
    RiGraduationCapLine,
    RiBriefcaseLine,
    RiFingerprint2Line,
    RiHomeLine,
    RiMedalLine,
    RiBankLine,
    RiHeartLine,
    RiFileCheckLine,
    RiBuilding2Line,
    RiScales3Line,
    RiCarLine,
    RiTeamLine,
    RiVipCrownLine,
    RiTrophyLine,
    RiShieldKeyholeLine,
};

const VpCategoryCard = ({id, name, description, icon, onClick}) => {

  const IconComponent = iconMap[icon];
  
  return (
    <div className='flex'>
    <div 
        id={id}
        className="flex flex-col bg-cfSecondary overflow-hidden transition-all rounded-lg bg-card text-card-foreground shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)] cursor-pointer w-full" onClick={onClick}>
        <div className="flex flex-col flex-grow space-y-1.5 p-6">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full border-[1.5px]">
        {/* <div className="h-6 w-6 text-indigo-600" dangerouslySetInnerHTML={{ __html: icon }} /> */}
        {IconComponent && <IconComponent className="h-6 w-6 text-indigo-600" />}
        </div>
        <h1 className="font-semibold tracking-tight text-xl" >{name}</h1>
        <p className="flex-grow">
            {description}
        </p>
        </div>
    </div>
    </div>
  )
}

export default VpCategoryCard
